import { assert_number_gte_1, assert_string_not_empty } from '@shared/asserts/utils_asserts';
import { DTO__base } from '@shared/common/DTO__base';
import { ENUM__dto_class_name } from '@shared/serialization/ENUM__dto_class_name';

export class RequestBuyCredits extends DTO__base {
  static _class_name_static: string = ENUM__dto_class_name.REQUEST_BUY_CREDITS;

  workspace_id!: string;
  credits_amount!: number;

  /*
   * METHODS
   */

  assert_standard_fields(): void {
    assert_string_not_empty(this.workspace_id);
    assert_number_gte_1(this.credits_amount);
  }
}
